import { render, staticRenderFns } from "./BumpModal.vue?vue&type=template&id=2faf1dfc&"
import script from "./BumpModal.vue?vue&type=script&lang=js&"
export * from "./BumpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports